import {
    type ChangeSaleKeysAction,
    SALE_KEYS_BACK,
    SALE_KEYS_CHANGE,
    SALE_KEYS_SET,
    type SaleKeysActionTypes,
} from "../../Actions/SellScreen/SellScreenSaleKeysActions";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";
import { getOption } from "../../Utilities/Platform/Options/Options";

export interface SaleKeysState {
    folders: Array<string | boolean>;
}

function SaleKeysChange(
    state: SaleKeysState,
    action: ChangeSaleKeysAction
): SaleKeysState {
    let index = state.folders.indexOf(action.uuid);

    if(index === -1) {
        index = state.folders.length;
    }

    return {
        folders: [
            ...state.folders.slice(0, index),
            action.uuid,
        ],
    };
}

function SaleKeysBack(
    state: SaleKeysState
): SaleKeysState {
    if(state.folders.length > 1) {
        return {
            folders: state.folders.slice(0, -1),
        };
    } else {
        return state;
    }
}

function SellScreenSaleKeysModeReducer(
    state: SaleKeysState,
    action: ShopfrontActions<SaleKeysActionTypes>
): SaleKeysState {
    if(typeof state === "undefined") {
        return {
            folders: [ getOption("default_sale_keys") ?? "" ],
        };
    }

    switch(action.type) {
        case SALE_KEYS_SET:
            return {
                folders: [ action.uuid ],
            };
        case SALE_KEYS_CHANGE:
            return SaleKeysChange(state, action);
        case SALE_KEYS_BACK:
            return SaleKeysBack(state);
        default:
            return state;
    }
}

export default SellScreenSaleKeysModeReducer;
